import { runInNewContext } from "../vm";

const evalCode = (code: string, context = {}, persistentContextId?: string) =>
  runInNewContext(code, context, persistentContextId);

export default evalCode;
